import * as React from "react";
import type { SVGProps } from "react";
const SvgUsersProfiles02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M19.2 13.686c1.267.947 2.4 3.33 2.4 4.8 0 .457-.334.828-.746.828H20.4m-4.8-9.51a2.742 2.742 0 0 0 0-4.751M3.146 19.314h13.137c.412 0 .746-.37.746-.828 0-2.877-2.404-5.209-7.315-5.209-4.91 0-7.314 2.332-7.314 5.209 0 .457.334.828.746.828ZM12.457 7.43a2.743 2.743 0 1 1-5.486 0 2.743 2.743 0 0 1 5.486 0Z"
    />
  </svg>
);
export default SvgUsersProfiles02;
